function SectionCandidateAbout2() {
    return (
        <>
            <div>
                <h4 className="twm-s-title m-t0">About Me</h4>
                <p>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur? </p>
                <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi.</p>
                <div>
                    <p>Professional Business Developer with more than four years of experience in the business development processes. Involved in product testing, management, and development of new business opportunities.</p>
                    <h4 className="twm-s-title">Personal Characteristics:</h4>
                    <ul className="description-list-2">
                        <li>
                            <i className="feather-check" />
                            I take constructive criticism well and I am comfortable voicing opinions.
                        </li>
                        <li>
                            <i className="feather-check" />
                            Available to work required shifts including weekends, evenings and holidays.
                        </li>
                        <li>
                            <i className="feather-check" />
                            Excellent customer service skills, communication skills, and a happy, smiling attitude are essential.
                        </li>
                        <li>
                            <i className="feather-check" />
                            I have great time management skills.
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default SectionCandidateAbout2;